module.exports = __webpack_public_path__ + "static/media/happy.5f61b0a8.svg";